import updateSubject from 'owa-mail-compose-store/lib/actions/updateSubject';
import updateSubjectSelectionRange from 'owa-mail-compose-store/lib/actions/updateSubjectSelectionRange';
export var getSubject = function (viewState) { return function () {
    return viewState.subject;
}; };
export var setSubject = function (viewState) { return function (subject) {
    updateSubject(viewState, subject);
}; };
export var setSubjectSelectedData = function (viewState) { return function (content) {
    if (!isSubjectLineLastFocusedControl(viewState)) {
        return;
    }
    var value = viewState.subject;
    var _a = viewState.subjectViewState, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd;
    value = value.slice(0, selectionStart) + content + value.slice(selectionEnd);
    updateSubject(viewState, value);
    var cursorPosition = selectionStart + content.length;
    updateSubjectSelectionRange(viewState, cursorPosition, cursorPosition);
}; };
export var getSubjectSelectedData = function (viewState) { return function () {
    if (!isSubjectLineLastFocusedControl(viewState)) {
        return null;
    }
    var _a = viewState.subjectViewState, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd;
    var value = viewState.subject;
    value = value.slice(selectionStart, selectionEnd);
    return {
        data: value,
        sourceProperty: 'subject',
        startPosition: selectionStart,
        endPosition: selectionEnd,
    };
}; };
function isSubjectLineLastFocusedControl(viewState) {
    return viewState.lastFocusedControl === 5 /* SubjectLine */;
}
//# sourceMappingURL=SubjectAdapter.js.map